(() => {
  'use strict';
  const configNode = document.querySelector('[data-saved-records-config]');
  if (!configNode || window.CCHWSavedRecords) return;
  const config = JSON.parse(configNode.textContent);
  const root = document.querySelector('[data-saved-records-page]:not([data-saved-compact])');
  const nativeFetch = window.fetch.bind(window);
  let cartRefreshRequest = 0;
  async function refreshCartCount() {
    const request = ++cartRefreshRequest;
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // Read the full cart: add.js returns added lines, not the cart's total quantity.
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const response = await nativeFetch(config.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
        if (!response.ok) throw new Error('Cart count unavailable');
        const cart = await response.json();
        if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart count');
        if (request !== cartRefreshRequest) return;
        document.querySelectorAll('.site-header__cart-link__count, .cartCount').forEach(node => {
          node.textContent = String(cart.item_count);
          node.classList.toggle('hidden-count', cart.item_count === 0);
        });
        document.dispatchEvent(new CustomEvent('cchw:cart-updated', { detail: { cart } }));
        return;
      } catch {
        // A failed badge refresh must never turn a successful add into an error.
        if (request !== cartRefreshRequest) return;
      }
    }
  }
  let sessionPromise;
  let page = 0;
  let playbackRequest = 0;
  const products = new Map();
  const audio = new Map();
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  function notice(text, isError = false, saved = false) {
    let node = document.querySelector('[data-saved-notice]');
    if (!node) {
      node = document.createElement('div');
      node.dataset.savedNotice = '';
      node.className = 'saved-notice';
      // Static icons only; all message text is assigned with textContent below.
      node.innerHTML = `<span class="saved-notice-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path class="saved-notice-heart" d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/><path class="saved-notice-check" d="m5 12 4 4L19 6"/><path class="saved-notice-error" d="M12 7v6m0 4h.01"/></svg></span><div class="saved-notice-copy"><span class="saved-notice-message" role="status" aria-atomic="true"></span><a class="saved-notice-link" hidden>View wishlist <span aria-hidden="true">↗</span></a></div><button class="saved-notice-close" type="button" aria-label="Dismiss wishlist notification"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="m7 7 10 10M17 7 7 17"/></svg></button>`;
      node.querySelector('.saved-notice-link').href = config.root + 'pages/wishlist';
      node.querySelector('button').addEventListener('click', () => { clearTimeout(notice.timer); node.hidden = true; });
      node.addEventListener('pointerenter', () => clearTimeout(notice.timer));
      node.addEventListener('focusin', () => clearTimeout(notice.timer));
      const resume = () => {
        if (!node.matches(':hover') && !node.contains(document.activeElement)) notice.dismiss();
      };
      node.addEventListener('pointerleave', resume);
      node.addEventListener('focusout', () => setTimeout(resume, 0));
      document.body.append(node);
    }
    node.querySelector('.saved-notice-message').textContent = text;
    node.querySelector('.saved-notice-link').hidden = !saved;
    node.classList.toggle('is-error', isError);
    node.classList.toggle('is-saved', saved);
    node.hidden = false;
    notice.dismiss = () => {
      clearTimeout(notice.timer);
      notice.timer = setTimeout(() => { node.hidden = true; }, isError ? 9000 : 5000);
    };
    clearTimeout(notice.timer);
    if (!node.matches(':hover') && !node.contains(document.activeElement)) notice.dismiss();
  }
  async function api(path, body) {
    const headers = { Accept: 'application/json' };
    if (body) { const state = await session(); headers['Content-Type'] = 'application/json'; headers['X-CCHW-CSRF'] = state.csrf; }
    const response = await nativeFetch(config.proxy + '/' + path, { method: body ? 'POST' : 'GET', headers, credentials: 'same-origin', cache: 'no-store', body: body ? JSON.stringify(body) : undefined, signal: AbortSignal.timeout(12000) });
    let result; try { result = await response.json(); } catch { throw new Error('The wishlist connection is not ready. Please try again shortly.'); }
    if (!response.ok) { const error = new Error(result.error || 'Please try again.'); error.status = response.status; throw error; }
    return result;
  }
  function session() {
    if (!sessionPromise) sessionPromise = api('session').catch(error => { sessionPromise = null; throw error; });
    return sessionPromise;
  }
  function login() { window.location.assign(config.login); }
  function money(cents) { return new Intl.NumberFormat(config.locale || 'en-GB', { style: 'currency', currency: config.currency || 'GBP' }).format(Number(cents) / 100); }
  async function product(handle) {
    if (!/^[a-z0-9][a-z0-9-]{0,200}$/.test(handle)) throw new Error('Record unavailable');
    if (!products.has(handle)) products.set(handle, nativeFetch(config.root + 'products/' + handle + '.js', { signal: AbortSignal.timeout(10000) }).then(async response => {
      if (!response.ok) throw new Error('Record unavailable'); return response.json();
    }).catch(error => { products.delete(handle); throw error; }));
    return products.get(handle);
  }
  function markHearts(state) {
    document.querySelectorAll('[data-saved-heart]').forEach(button => {
      const selected = state.wishlist.includes(button.dataset.variantId);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? 'Remove from wishlist' : 'Save to wishlist');
      button.title = selected ? 'Remove from wishlist' : 'Save to wishlist';
    });
  }
  async function toggleHeart(button) {
    if (!config.loggedIn) { login(); return; }
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true'); button.disabled = true;
    try {
      const state = await session();
      const selector = button.closest('.product-form')?.querySelector('[name="id"]');
      const variantId = selector?.value || button.dataset.variantId;
      button.dataset.variantId = variantId;
      const selected = state.wishlist.includes(variantId);
      await api('wishlist', { action: selected ? 'remove' : 'add', variantId, handle: button.dataset.handle });
      state.wishlist = selected ? state.wishlist.filter(id => id !== variantId) : [...state.wishlist, variantId];
      markHearts(state); notice(selected ? 'Removed from wishlist' : 'Saved to your wishlist', false, !selected);
    } catch (error) { notice(error.message, true); } finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  }
  async function listen(button, handle) {
    const requestId = ++playbackRequest;
    button.disabled = true; button.classList.add('is-loading'); button.setAttribute('aria-label', 'Loading preview');
    try {
      if (!audio.has(handle)) audio.set(handle, nativeFetch(config.root + 'products/' + handle + '?view=cchw-audio-json', { signal: AbortSignal.timeout(12000) }).then(async response => {
        if (!response.ok) throw new Error('Preview unavailable'); return response.json();
      }).catch(error => { audio.delete(handle); throw error; }));
      const record = await audio.get(handle);
      if (requestId !== playbackRequest) return;
      if (!record.tracks?.length) throw new Error('No audio preview for this record');
      if (!window.CCHWPlayer?.loadTracks) throw new Error('The music player is still starting. Please tap Listen again.');
      window.CCHWPlayer.loadTracks(record.tracks);
    } catch (error) { if (requestId === playbackRequest) notice(error.message, true); }
    finally { button.disabled = false; button.classList.remove('is-loading'); button.setAttribute('aria-label', 'Listen to this record'); }
  }
  function card(item, record) {
    const variant = record?.variants?.find(variant => String(variant.id) === item.variantId);
    const available = Boolean(variant?.available);
    const tags = record?.tags || [];
    const preorder = tags.some(tag => /^(pre[- ]?order|preorders)$/i.test(tag));
    const image = record?.featured_image;
    let imageUrl = '';
    if (image) { const url = new URL(image, location.origin); if (url.protocol === 'https:') { url.searchParams.set('width', '240'); imageUrl = url.href; } }
    return `<article class="saved-record" data-variant-id="${esc(item.variantId)}" data-handle="${esc(item.handle)}">
      <a class="saved-art" href="${config.root}products/${esc(item.handle)}">${imageUrl ? `<img src="${esc(imageUrl)}" alt="${esc(record.title)}" width="120" height="120" loading="lazy">` : '<span aria-hidden="true">◎</span>'}</a>
      <div class="saved-detail">${preorder ? '<span class="saved-badge">Pre-order</span>' : ''}
        <h2><a href="${config.root}products/${esc(item.handle)}">${esc(record?.title || 'Record details temporarily unavailable')}</a></h2>
        <p class="saved-label">${esc(record?.vendor || '')}</p>
        <p class="saved-price">${variant ? money(variant.price) : ''}${variant && config.exVat ? '<small> excl VAT</small>' : ''}</p>
        <span class="saved-availability">${available ? (preorder ? 'Ships on release' : 'In stock') : 'Currently unavailable'}</span>
      </div>
      <div class="saved-actions"><button class="saved-listen" data-saved-listen ${record ? '' : 'disabled'}><span class="saved-disc" aria-hidden="true">▶</span> Listen</button>
      <button class="saved-add" data-saved-add ${available ? '' : 'disabled'}>${preorder ? 'Pre-order' : 'Add to cart'}</button>
      <button class="saved-remove" data-saved-remove>Remove</button></div>
    </article>`;
  }
  async function render() {
    if (!root || !config.loggedIn) return;
    const status = root.querySelector('[data-saved-status]');
    const grid = root.querySelector('[data-saved-grid]');
    status.textContent = 'Loading your saved records…';
    grid.setAttribute('aria-busy', 'true');
    try {
      await session();
      const result = await api('wishlist?page=' + page);
      const records = new Array(result.items.length);
      let next = 0;
      await Promise.all(Array.from({ length: Math.min(4, records.length) }, async () => {
        while (next < records.length) { const i = next++; try { records[i] = await product(result.items[i].handle); } catch { records[i] = null; } }
      }));
      grid.innerHTML = result.items.map((item, i) => card(item, records[i])).join('');
      root.querySelector('[data-saved-count]').textContent = result.total + (result.total === 1 ? ' saved record' : ' saved records');
      status.textContent = result.total ? '' : 'Your next favourite is out there. Tap a heart to save it here.';
      root.querySelector('[data-saved-previous]').disabled = page === 0;
      root.querySelector('[data-saved-next]').disabled = (page + 1) * 12 >= result.total;
      root.querySelector('[data-saved-pages]').textContent = result.total ? `${page * 12 + 1}–${Math.min((page + 1) * 12, result.total)} of ${result.total}` : '';
      root.querySelector('[data-saved-retry]').hidden = true;
    } catch (error) { status.textContent = error.message; root.querySelector('[data-saved-retry]').hidden = false; }
    finally { grid.setAttribute('aria-busy', 'false'); }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('button, [data-saved-heart]'); if (!button) return;
    if (button.matches('[data-saved-heart]')) { event.preventDefault(); await toggleHeart(button); return; }
    if (!root?.contains(button)) return;
    if (button.matches('[data-saved-retry]')) { sessionPromise = null; render(); return; }
    if (button.matches('[data-saved-next], [data-saved-previous]')) { page += button.hasAttribute('data-saved-next') ? 1 : -1; render(); return; }
    const row = button.closest('[data-variant-id]'); if (!row) return;
    if (button.matches('[data-saved-listen]')) { listen(button, row.dataset.handle); return; }
    button.disabled = true;
    try {
      if (button.matches('[data-saved-remove]')) {
        await api('wishlist', { action: 'remove', variantId: row.dataset.variantId });
        const state = await session(); state.wishlist = state.wishlist.filter(id => id !== row.dataset.variantId);
        if (root.querySelectorAll('.saved-record').length === 1 && page > 0) page--;
        await render(); markHearts(state); notice('Removed from wishlist');
      } else if (button.matches('[data-saved-add]')) {
        const response = await window.fetch(config.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: row.dataset.variantId, quantity: 1 }] }) });
        const result = await response.json(); if (!response.ok) throw new Error(result.description || 'Could not add this record');
        button.textContent = '✓ Added'; notice('Added to cart. Your record is still saved here.');
        refreshCartCount();
        setTimeout(() => { button.textContent = 'Add to cart'; }, 1800);
      }
    } catch (error) { notice(error.message, true); } finally { button.disabled = false; }
  });
  window.CCHWSavedRecords = { config, api, session, notice, nativeFetch, listen, markHearts, refreshCartCount };
  document.dispatchEvent(new Event('cchw:saved-records-ready'));
  if (config.loggedIn) { session().then(markHearts).catch(() => {}); render(); }
})();
